// Menu Data - SANTOMATO Pizzeria
// Menu definitivo: 31 pizze + 5 fritti = 36 referenze

export const menuCategories = {
  tradizione: {
    name: "PIZZE TRADIZIONALI",
    description: "I grandi classici della pizza italiana",
    items: [
      {
        id: "trad-1",
        name: "BUFALA",
        description: "Pomodoro, mozzarella di bufala campana.",
        price: 9.50
      },
      {
        id: "trad-2",
        name: "CAPRICCIOSA",
        description: "Pomodoro, mozzarella, prosciutto cotto, funghi, carciofi.",
        price: 10.00
      },
      {
        id: "trad-3",
        name: "MARGHERITA",
        description: "Pomodoro, mozzarella.",
        price: 7.00
      },
      {
        id: "trad-4",
        name: "MARINARA",
        description: "Pomodoro, olio all'aglio, origano.",
        price: 6.50
      },
      {
        id: "trad-5",
        name: "NAPOLETANA",
        description: "Pomodoro, mozzarella, acciughe, origano.",
        price: 8.00
      },
      {
        id: "trad-6",
        name: "PROSCIUTTO & FUNGHI",
        description: "Pomodoro, mozzarella, prosciutto cotto, funghi.",
        price: 9.50
      },
      {
        id: "trad-7",
        name: "PUGLIESE",
        description: "Pomodoro, mozzarella, cipolle, Grana Padano.",
        price: 9.00
      },
      {
        id: "trad-8",
        name: "QUATTRO FORMAGGI",
        description: "Pomodoro, mozzarella, gorgonzola, brie, Grana Padano.",
        price: 11.00
      },
      {
        id: "trad-9",
        name: "SALAMINO",
        description: "Pomodoro, mozzarella, salamino piccante.",
        price: 9.00
      },
      {
        id: "trad-10",
        name: "SANDRINO",
        description: "Pomodoro, mozzarella di bufala campana, salamino piccante, gorgonzola.",
        price: 12.00
      },
      {
        id: "trad-11",
        name: "SPECK & BRIE",
        description: "Pomodoro, mozzarella, speck, brie.",
        price: 11.50
      },
      {
        id: "trad-12",
        name: "VERDURE",
        description: "Pomodoro, mozzarella, zucchine, peperoni, melanzane.",
        price: 10.50
      },
      {
        id: "trad-13",
        name: "VESUVIO",
        description: "Pomodoro, mozzarella di bufala campana, pomodorini, rucola.",
        price: 11.50
      },
      {
        id: "trad-14",
        name: "WÜRSTEL & PATATINE",
        description: "Pomodoro, mozzarella, würstel, patatine*.",
        price: 10.50
      }
    ]
  },
  territorio: {
    name: "PIZZE DEL TERRITORIO",
    description: "Tradizioni culinarie locali e eccellenze dei produttori vicini",
    items: [
      {
        id: "ter-1",
        name: "BRESCIANA",
        description: "Pomodoro, mozzarella, salamino piccante, gorgonzola.",
        price: 11.00
      },
      {
        id: "ter-2",
        name: "CARCIOFA",
        description: "Pomodoro, mozzarella, carciofi alla romana, fiocchetto.",
        price: 11.50
      },
      {
        id: "ter-3",
        name: "DELLA CASA",
        description: "Pomodoro, mozzarella di bufala campana, crudo di Parma 24 mesi, porcini.",
        price: 14.00
      },
      {
        id: "ter-4",
        name: "MANTOVANA",
        description: "Crema di zucca, mozzarella, salsiccia, gorgonzola.",
        price: 10.50
      },
      {
        id: "ter-5",
        name: "MARTINONI",
        description: "Mozzarella, gorgonzola piccante, miele, noci.",
        price: 10.50
      },
      {
        id: "ter-6",
        name: "NEBBIA",
        description: "Mozzarella, gorgonzola, brie, Grana Padano, funghi porcini, salsiccia.",
        price: 13.00
      },
      {
        id: "ter-7",
        name: "OLGA",
        description: "Pomodoro, mozzarella, basilico, crudo, pomodori secchi, stracciatella.",
        price: 14.00
      },
      {
        id: "ter-8",
        name: "PARMENSE",
        description: "Pomodoro, mozzarella, crudo di Parma 24 mesi, scamorza affumicata, funghi porcini.",
        price: 14.00
      },
      {
        id: "ter-9",
        name: "SANTOMATO",
        description: "Pomodoro, mozzarella, carciofi alla romana, pomodori secchi, salsiccia.",
        price: 12.50,
        isSpecial: true
      },
      {
        id: "ter-10",
        name: "SELVATICA",
        description: "Crema di zucca, mozzarella, salsiccia, porcini, pecorino.",
        price: 13.00
      },
      {
        id: "ter-11",
        name: "TONNO & CIGOLE",
        description: "Pomodoro, mozzarella, tonno, cipolle.",
        price: 10.00
      }
    ]
  },
  signature: {
    name: "PIZZE SIGNATURE",
    description: "Ingredienti top e abbinamenti originali per un'esperienza gourmet",
    items: [
      {
        id: "sig-1",
        name: "MEDITERRANEA",
        description: "Pomodoro, mozzarella di bufala, crudo di Parma 24 mesi, pomodorini, rucola.",
        price: 12.50
      },
      {
        id: "sig-2",
        name: "CRUDO & BURRATA",
        description: "Pomodoro, mozzarella, burrata, crudo di Parma 24 mesi.",
        price: 14.00
      },
      {
        id: "sig-3",
        name: "FIOCCATA",
        description: "Pomodoro, mozzarella, burrata, fiocchetto, rucola.",
        price: 14.00
      },
      {
        id: "sig-4",
        name: "REGINA",
        description: "Mozzarella, brie, noci, speck, miele.",
        price: 12.50
      },
      {
        id: "sig-5",
        name: "SPAKÖ OSS",
        description: "Pomodoro, mozzarella, gorgonzola, salamino piccante, acciughe, cipolle, capperi, peperoni.",
        price: 14.00
      },
      {
        id: "sig-6",
        name: "TRENTINA",
        description: "Pomodoro, mozzarella, speck, gorgonzola, funghi.",
        price: 12.00
      }
    ]
  },
  fritti: {
    name: "FRITTI",
    description: "L'inizio perfetto",
    items: [
      {
        id: "fritto-1",
        name: "PATATINE FRITTE",
        description: "Patatine fritte.",
        price: 5.00
      },
      {
        id: "fritto-2",
        name: "JALAPEÑO RIPIENI DI FORMAGGIO",
        description: "Jalapeño ripieni di formaggio.",
        price: 7.00
      },
      {
        id: "fritto-3",
        name: "STRACCETTI DI POLLO",
        description: "Straccetti di pollo.",
        price: 7.00
      },
      {
        id: "fritto-4",
        name: "STICK DI MOZZARELLA PANATI",
        description: "Stick di mozzarella panati.",
        price: 7.00
      },
      {
        id: "fritto-5",
        name: "PEPITE PULLED PORK",
        description: "Pepite di pulled pork.",
        price: 8.00
      }
    ]
  }
};

export const drinks = {
  birre: {
    name: "BIRRE",
    items: [
      {
        id: "birra-1",
        name: "PAULANER HEFE WEISS",
        description: "Weissbier tedesca classica, non filtrata. 5,5%",
        price: 5.00,
        size: "50cl"
      },
      {
        id: "birra-2",
        name: "BREWFIST BUROCRACY",
        description: "IPA ambrata e luppolata. 6,0%",
        price: 6.00,
        size: "50cl"
      },
      {
        id: "birra-3",
        name: "PAULANER MÜNCHNER HELL",
        description: "Classica birra bionda tedesca. 4,9%",
        prices: { piccola: 3.50, media: 5.00 },
        isSpina: true
      },
      {
        id: "birra-4",
        name: "PAULANER MÄRZEN",
        description: "Birra ambrata stile Märzen. 5,8%",
        prices: { piccola: 3.50, media: 5.00 },
        isSpina: true
      }
    ]
  },
  bibite: {
    name: "BIBITE FREE REFILL",
    price: 4.00,
    note: "Bevi quanto vuoi a prezzo fisso! Servizio strettamente personale.",
    brands: ["PEPSI", "PEPSI ZERO", "LIPTON ICE TEA LIMONE", "LIPTON ICE TEA PESCA"]
  },
  lattine: {
    name: "BIBITE IN LATTINA",
    price: 3.50
  }
};

export const extras = {
  pizzaBaby: { name: "PIZZA BABY", price: 0.50 },
  coperto: { name: "Servizio e Coperto", price: 2.50 }
};

export const locations = [
  {
    id: "cigole",
    name: "CIGOLE",
    address: "Via Antonio Farina, 44",
    city: "Cigole (BS)",
    phone: "030.7992227",
    hours: "Gio-Dom 19:00/22:30",
    note: "Lunedì, Martedì e Mercoledì chiuso",
    isOpen: true,
    mapUrl: "https://maps.google.com/?q=Via+Antonio+Farina+44+Cigole+BS"
  },
  {
    id: "villagana",
    name: "VILLAGANA",
    address: "Frazione Villagana 25",
    city: "25030 Villachiara (BS)",
    hostedBy: "presso Pizzeria dal Conte",
    phone: "331 890 6495",
    hours: "Mer-Dom 19:00/22:30",
    note: "Lunedì e Martedì chiuso",
    email: "info@pizzeriadalconte.it",
    website: "https://www.pizzeriadalconte.it/",
    mapUrl: "https://maps.app.goo.gl/kM1gSFUEApkestN27",
    logo: "https://customer-assets-lxgj4vgw.emergentagent.net/job_santomato-pizza/artifacts/ae69a34e07f6b671_Esecutivi-logo-DAL-CONTE-1.jpg",
    isOpen: true
  }
];

export const reviews = [
  {
    id: 1,
    text: "Finalmente una pizza come si deve. Grande, croccante e a prezzi giusti!",
    author: "Marco B.",
    rating: 5
  },
  {
    id: 2,
    text: "Spendi poco e mangi tanto. Il free refill è geniale!",
    author: "Giulia R.",
    rating: 5
  },
  {
    id: 3,
    text: "Atmosfera fantastica, perfetta per una serata con gli amici.",
    author: "Luca M.",
    rating: 5
  },
  {
    id: 4,
    text: "La pizza Santomato è spettacolare. Torneremo sicuramente!",
    author: "Francesca D.",
    rating: 5
  },
  {
    id: 5,
    text: "Porzioni generose! I miei figli adorano questo posto.",
    author: "Andrea P.",
    rating: 5
  },
  {
    id: 6,
    text: "Servizio velocissimo e pizza super. Consigliatissimo!",
    author: "Sara T.",
    rating: 5
  }
];
